import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import styles from "./RowList.module.scss"

const RowList = ({
  children,
  gutterSize = "small",
  columns = 2,
  specialClass,
  background,
}) => {
  const chunk = (input, size) => {
    return input.reduce((arr, item, idx) => {
      return idx % size === 0
        ? [...arr, [item]]
        : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]]
    }, [])
  }

  const rows = chunk(React.Children.toArray(children), columns)

  const camelCase = require("camelcase")

  return (
    <div
      className={`${styles.list} ${styles[camelCase("" + background)]} ${
        background
          ? "make-full-width-on-mobile make-full-width-on-mobile-with-paddings"
          : false
      } base-margin-top-small`}
    >
      {rows.map((cols, index) => (
        <Row
          className={"row-" + gutterSize + "-gutters " + specialClass}
          key={index}
        >
          {cols.map((col, index) => (
            <Col md={12 / columns} key={index}>
              {col}
            </Col>
          ))}
        </Row>
      ))}
    </div>
  )
}

export default RowList
